import { createSelector } from 'reselect';

const slice = ({ staticPages }) => staticPages;

export const staticPagesSelector = createSelector(slice, ({ items }) => items && items.results);



// WEBPACK FOOTER //
// ./src/selectors/staticPages.js